import React from 'react'
import BlogRoutes from './blog.routes'
import HomeHeader from '../home/header/home-header'

const Blog = () => {
  return (
    <>
      <HomeHeader type={2} />
      <BlogRoutes />
    </>
  )
}

export default Blog
